import { type FC, type ReactNode } from "react";

import { clsx } from "clsx";

import { faChevronDown } from "@fortawesome/pro-duotone-svg-icons/faChevronDown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Controls that belong together (Edit | •••, Copy | Download | Settings, a
// row's actions) share one quiet pill, split by hairlines. On a phone, `wrap`
// splits it into one pill per control that wrap onto the next line; `icons`
// keeps one pill and shows each button's icon alone.
export const PillGroup: FC<{
  phone?: "wrap" | "icons";
  children: ReactNode;
}> = ({ phone, children }) => (
  <div className={clsx("pill-group", phone && `pill-group--${phone}`)}>
    {children}
  </div>
);

// A button's words; screen readers only on a phone in an `icons` group.
export const PillLabel: FC<{ children: ReactNode }> = ({ children }) => (
  <span className="pill-label">{children}</span>
);

// A menu button's chevron; dropped on a phone in an `icons` group.
export const PillChevron: FC = () => (
  <FontAwesomeIcon icon={faChevronDown} size="xs" className="pill-chevron" />
);

// A line of status inside the group, sized like the buttons beside it.
export const PillNote: FC<{ children: ReactNode }> = ({ children }) => (
  <span className="inline-flex h-8 items-center px-3 text-xs whitespace-nowrap text-indigo-600">
    {children}
  </span>
);
